import { filterProps } from '../../../theming'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

export function extractStyleSystemProps(others) {
  const {
    m,
    mx,
    my,
    mt,
    mb,
    ml,
    mr,
    p,
    px,
    py,
    pt,
    pb,
    pl,
    pr,
    w,
    miw,
    maw,
    h,
    mih,
    mah,
    bg,
    c,
    fill,
    opacity,
    pos,
    top,
    left,
    bottom,
    right,
    display,
    flex,
    flexGrow,
    flexShrink,
    flexBasis,
    alignContent,
    alignItems,
    alignSelf,
    flexDirection,
    justifyContent,
    flexWrap,
    order,
    gap,
    overflow,
    overflowX,
    overflowY,
    zIndex,
    ta,
    va,
    fontSize,
    fw,
    bs,
    bc,
    bw,
    btw,
    bbw,
    blw,
    brw,
    br,
    btr,
    bbr,
    btlr,
    btrr,
    bblr,
    bbrr,
    transition,
    transform,
    backgroundImage,
    backgroundSize,
    backgroundRepeat,
    backgroundPosition,
    objectFit,
    aspectRatio,
    ...rest
  } = others;
  const styleSystemProps = filterProps({
    m,
    mx,
    my,
    mt,
    mb,
    ml,
    mr,
    p,
    px,
    py,
    pt,
    pb,
    pl,
    pr,
    w,
    miw,
    maw,
    h,
    mih,
    mah,
    bg,
    c,
    fill,
    opacity,
    pos,
    top,
    left,
    bottom,
    right,
    display,
    flex,
    flexGrow,
    flexShrink,
    flexBasis,
    alignContent,
    alignItems,
    alignSelf,
    flexDirection,
    justifyContent,
    flexWrap,
    order,
    gap,
    overflow,
    overflowX,
    overflowY,
    zIndex,
    ta,
    va,
    fontSize,
    fw,
    bs,
    bc,
    bw,
    btw,
    bbw,
    blw,
    brw,
    br,
    btr,
    bbr,
    btlr,
    btrr,
    bblr,
    bbrr,
    transition,
    transform,
    backgroundImage,
    backgroundSize,
    backgroundRepeat,
    backgroundPosition,
    objectFit,
    aspectRatio
  });
  return {
    styleSystemProps,
    rest: rest
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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